import { render } from "./AdminPage.vue?vue&type=template&id=f28c5c7e&scoped=true"
import script from "./AdminPage.vue?vue&type=script&lang=ts"
export * from "./AdminPage.vue?vue&type=script&lang=ts"

import "./AdminPage.vue?vue&type=style&index=0&id=f28c5c7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f28c5c7e"

export default script